import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { tabs } from 'src/app/dummy/tabs';
import { AddCountryComponent } from './add-country/add-country.component';
import { DataService } from 'src/app/services/data.service';
import { List } from 'src/app/stores/administrator/list.store';

@Component({
  selector: 'app-geo-data',
  templateUrl: './geo-data.component.html',
  styleUrls: ['./geo-data.component.scss']
})
export class GeoDataComponent implements OnInit {
  tabs = tabs.GEO

  constructor(
    private router: Router,
    public store: List,
    public ds: DataService,
    public dialog: MatDialog) { }

  create(event) {
    const dialogRef = this.dialog.open(AddCountryComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  ngOnInit() {
    this.store.fetchData(this.ds.countryRef(ref => ref.orderBy("code")))
  }

  ngOnDestroy() {
    this.store.dispost();
  }
}
